<template>
    <div class="home">
        <video 
            ref="videoPlayer"
            autoplay 
            class="hero-video" 
            playsinline
            controls  
               muted 
        >
            <source :src="currentVideoSrc" type="video/mp4">
        </video>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

// 直接import引入视频文件
import video1 from '../store/new/video-zta-pc-1.mp4'
import video2 from '../store/new/video-zta-pc-2.mp4'

// 当前播放的视频源
const currentVideoSrc = ref(video1)
// 视频元素引用
const videoPlayer = ref(null)
// 标记第一个视频是否已播放过
const firstVideoPlayed = ref(false)

onMounted(() => {
    // 监听视频播放结束事件
    videoPlayer.value.addEventListener('ended', handleVideoEnded)
})

// 处理视频播放结束
const handleVideoEnded = () => {
    if (!firstVideoPlayed.value) {
        // 第一个视频播放完毕，切换到第二个视频并设置循环
        currentVideoSrc.value = video2
        videoPlayer.value.loop = true
        firstVideoPlayed.value = true
        
        // 加载并播放第二个视频
        videoPlayer.value.load()
        videoPlayer.value.play().catch(err => {
            console.log('播放失败:', err)
        })
    }
}
</script>

<style scoped>
.home {
    height: 100vh;
    width: 100%;
    overflow: hidden;
    position: relative;
}

.hero-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}
</style>
    